import './application.css';

import { createApp } from 'vue/dist/vue.esm-bundler';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { createPinia } from 'pinia';
const pinia = createPinia();

import '@/mixins/filters';
import store from '@/store/index';
import Notifications from 'vue3-vt-notifications';
import Interceptors from '@/helpers/response_handler';
import ResizeTextarea from 'resize-textarea-vue3';
import emitter from 'tiny-emitter/instance';
import { VueMasonryPlugin } from 'vue-masonry/src/masonry.plugin';

import colors from 'tailwindcss/colors';
import TheTIEDesignSystem from '@the-tie/the_tie_design_system';
import '@the-tie/the_tie_design_system/dist/style.css';

import Appsignal from '@appsignal/javascript';
import { errorHandler } from '@appsignal/vue';
const appsignal = new Appsignal({
  key:
    window.location.hostname.includes('sigdev.thetie.io') || window.location.hostname.includes('terminal.thetie.io')
      ? '8b569f92-0858-4820-a758-a14b2f1e46ac' // production
      : '8a92c9ca-ebab-4044-ad7e-7347717ae9fd' // staging
});

import DefaultComponentsPlugin from '@/plugins/default_components';
import NftLayout from '@/components/nft/NftLayout.vue';
import AdminIndex from '@/components/admin/AdminIndex.vue';
import AppLayout from '@/components/AppLayout.vue';
import ModalCoinSideBar from '@/components/modal/ModalCoinSideBar.vue';
import NoDataFound from '@/components/NoDataFound.vue';
import ModalBase from '@/components/modal/ModalBase.vue';
import ModalAddToWatchlist from '@/components/modal/ModalAddToWatchlist.vue';
import ModalEditTags from '@/components/modal/ModalEditTags.vue';
import GlobalSearch from '@/components/GlobalSearch.vue';
import ModalConfirmation from '@/components/modal/ModalConfirmation.vue';

import HighchartsVue from 'highcharts-vue';

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('app').click();
  // Initialize Vue instance
  createInertiaApp({
    progress: {
      color: colors.blue[500]
    },
    resolve: name => {
      const pages = import.meta.glob('../components/**/*.vue');
      const page = pages[`../components/${name}.vue`]();
      page.then(module => {
        if (name.startsWith('nft/')) module.default.layout = [AppLayout, NftLayout];
        else if (name.startsWith('admin/') && name != 'admin/AdminIndex')
          module.default.layout = [AppLayout, AdminIndex];
        else module.default.layout = module.default.layout || AppLayout;
      });
      return page;
    },
    chunkUrl: name => {
      return `${process.env.CLOUDFRONT_URL}/${name}.js`;
    },
    setup({ el, App, props, plugin }) {
      const app = createApp(App, props);
      app.use(store);
      app.use(pinia);
      app.config.errorHandler = errorHandler(appsignal, app);
      app.config.globalProperties.$eventHub = {
        $on: (...args) => emitter.on(...args),
        $once: (...args) => emitter.once(...args),
        $off: (...args) => emitter.off(...args),
        $emit: (...args) => emitter.emit(...args)
      }; //global event bus
      app.provide('eventHub', app.config.globalProperties.$eventHub);
      app.use(Notifications);
      app.use(Interceptors);
      app.use(VueMasonryPlugin);
      app.use(ResizeTextarea);
      app.use(TheTIEDesignSystem);
      app.use(DefaultComponentsPlugin);
      app.use(plugin);

      // Globally required components
      app.component('ModalCoinSideBar', ModalCoinSideBar);
      app.component('NoDataFound', NoDataFound);
      app.component('ModalBase', ModalBase);
      app.component('ModalAddToWatchlist', ModalAddToWatchlist);
      app.component('ModalEditTags', ModalEditTags);
      app.component('GlobalSearch', GlobalSearch);
      app.component('ModalConfirmation', ModalConfirmation);

      app.use(HighchartsVue);

      router.on('error', event => {
        console.log('ERROR', event);
        let exception = event.detail?.exception;
        if (exception?.message === 'Network Error') {
          window.location = exception?.config?.url;
        }
      });
      router.on('finish', event => {
        if (event?.detail?.visit?.completed && event.detail?.visit?.url?.pathname) {
          store.dispatch('savePageVisits', {
            path: event.detail?.visit?.url?.pathname,
            name: event?.detail?.visit?.url?.pathname?.split('/')?.[1]
          });
        }
      });
      app.mount(el);
    }
  });
});
